import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../../libs'
import { WalletSummary } from './types'

export const walletsSummaryMounted = createEvent()

export const getWalletsSummary = fx<void, WalletSummary>({
  method: 'GET',
  url: '/finance/wallet/summary',
})

export const $walletsSummary = restore<WalletSummary>(
  getWalletsSummary.doneData.map((a) => a.body),
  {
    totalBalanceUsd: 0,
    totalInProcess: 0,
    totalLP: 0,
    totalPassive: 0,
    grandTotal: 0,
  },
)

sample({
  clock: walletsSummaryMounted,
  fn: () => ({}),
  target: getWalletsSummary,
})
